module.exports = __webpack_public_path__ + "static/media/A6CBCF7F-A4E8-4284-A0B9-2DD9570D68A1.37892fe2.bin";